import React from 'react';

export function Button({
  children,
  variant = 'primary', // 'primary' | 'secondary' | 'outline' | 'danger' | 'ghost'
  size = 'md', // 'sm' | 'md' | 'lg'
  icon: Icon,
  iconPosition = 'left',
  loading = false,
  disabled = false,
  onClick,
  className = '',
  type = 'button',
  fullWidth = false,
  style = {}
}) {
  const baseStyles = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    fontWeight: 600,
    borderRadius: 'var(--radius-md)',
    border: 'none',
    cursor: disabled || loading ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.6 : 1,
    transition: 'all var(--transition-fast)',
    textDecoration: 'none',
    width: fullWidth ? '100%' : 'auto',
    position: 'relative',
    overflow: 'hidden',
    ...style
  };

  const sizeStyles = {
    sm: { padding: '8px 14px', fontSize: '13px' },
    md: { padding: '11px 20px', fontSize: '14px' },
    lg: { padding: '14px 28px', fontSize: '16px' }
  };

  const variantStyles = {
    primary: {
      background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
      color: '#FFFFFF',
      boxShadow: '0 4px 12px rgba(5, 150, 105, 0.35)'
    },
    secondary: {
      background: 'linear-gradient(135deg, #0284C7 0%, #0369A1 100%)',
      color: '#FFFFFF',
      boxShadow: '0 4px 12px rgba(2, 132, 199, 0.3)'
    },
    outline: {
      background: 'transparent',
      color: 'var(--text-main)',
      border: '1px solid var(--border-color)'
    },
    danger: {
      background: 'linear-gradient(135deg, #DC2626 0%, #B91C1C 100%)',
      color: '#FFFFFF'
    },
    ghost: {
      background: 'transparent',
      color: 'var(--text-muted)'
    }
  };

  const combinedStyles = {
    ...baseStyles,
    ...sizeStyles[size],
    ...variantStyles[variant]
  };

  return (
    <button
      type={type}
      style={combinedStyles}
      onClick={disabled || loading ? undefined : onClick}
      disabled={disabled || loading}
      className={`btn-component ${className}`}
    >
      {loading ? (
        <span style={{
          width: '16px',
          height: '16px',
          border: '2px solid rgba(255,255,255,0.3)',
          borderTopColor: '#FFFFFF',
          borderRadius: '50%',
          display: 'inline-block',
          animation: 'spin 0.8s linear infinite'
        }} />
      ) : (
        <>
          {Icon && iconPosition === 'left' && <Icon size={size === 'sm' ? 15 : size === 'lg' ? 20 : 18} />}
          <span>{children}</span>
          {Icon && iconPosition === 'right' && <Icon size={size === 'sm' ? 15 : size === 'lg' ? 20 : 18} />}
        </>
      )}
    </button>
  );
}

export default Button;
